// @ts-nocheck
import React from "react";
import FormSection from "classes/Forms/components/FormViewer/components/FormSection/FormSection";
import EditDrawer from "components/EditDrawer/EditDrawer";
import { t } from "i18next";
import "./FormFiller.css";
import FilledFormSendStep from "./components/FilledFormSendStep";
import FilledFormEndStep from "./components/FilledFormEndStep";
import FormFetcher from "classes/Forms/components/FormFetcher/FormFetcher";
import useAccount from "classes/Accounts/hooks/useAccount";
import genRequest from "includes/request";
import FormAnswerModel, { answerValue } from "classes/Forms/FormAnswerModel";
import {getQuestionType} from "classes/Forms/QuestionsTypes";

export default function FormFiller(props) {
	const {form} = props;

	if (!props.isOpen)
		return (false);

	return (
		<div className="FormFiller h-100 overflow-hidden">
			<FormFetcher
				formId={form.id}
				{...props}
			>
				{
					(data) => {
						return (<FormFillerBody {...props} form={data}/>);
					}
				}
			</FormFetcher>
		</div>
	);
}

function FormFillerBody(props) {
	const {	account } = useAccount();
	const {form} = props;

	const disp_answers = () => {
		form.questions.forEach((a) => {
			let q = getQuestion(a.questionId);
			let ans = getQuestionAnswer(a.questionId);
			if (!ans)
				return (false);
			q.answers = ans.map((b) => new FormAnswerModel(b))
		})
	}

	const getQuestion = (qId) => {
		for (let x in form.sections)
		{
			let found = form.sections[x].questions?.find((b) => (b.questionId === qId ? b : false));
			if (found)
				return (found);
		}
		return (false);
	}

	const getQuestionAnswer = (qId) => {
		if (!form.userAnswers?.length)
			return (false);
		let found = form.userAnswers.filter((a) => a.questionId === qId);
		return (found || false);
	}

	const fetchAnswers = () => {
		let req = genRequest(`forms/${form.id}/employee-answers/${account.employeeId}`).then((resp) => {
			form.userAnswers = resp;
			disp_answers();
		})
		return (req);
	}

	let steps = [];

	if (form?.sections?.length)
		steps = form.sections.map((a, b) => {
			return ({
				component: FormSection,
				name: "FormSection-" + b,
				title: (form.sections?.length > 1 ? t("Forms.SECTION_INDEX", {index: b + 1}) : t("Forms.QUESTIONS")),
				props: {
					isAnonymous: form.isAnonymous,
					section: a
				},
				onNext: () => checkSection(a, form)
			});
		});

	steps.push({
		name: "send",
		disableNav: true,
		sendStep: true,
		title: t("Posts.SEND_STEP"),
		component: FilledFormSendStep
	}, {
		name: "preview",
		title: t("Posts.PREVIEW_STEP"),
		disableLink: true,
		component: FilledFormEndStep
	});

	if (!form)
		return (false);

	return (
		<EditDrawer
			steps={steps}
			onClose={props.onClose}
			object={form}
			isOpen={props.isOpen}
			title={form.title}
			initQueries={[
				{
					queryKey: ["Form", "FormAnswer", "OfEmployeAndForm", account.employeeId, form.id, Date.now()],
					queryFn: fetchAnswers
				}
			]}
		/>
	);
}

function checkSection(section, form) {
	document.querySelectorAll(".field-error").forEach(a => a.classList.remove("field-error"));
	if (!section?.questions?.length)
		return (true);

	const checkQuestion = (q) => {
		let type = getQuestionType(q.questionDesignId);
		if (!type)
			return ("Type de question non reconnu, veuillez sélectionner un type existant");
		if (!type.fillValidation)
			return (true);
		return (type.fillValidation(q.answers, q.options));
	}

	const error = (quest, text) => {
		let elem = document.querySelector("[data-form-question-id='" + quest.questionId + "'")
		let drawer = document.querySelector(".edit-drawer");

		elem?.classList.add("field-error");

		if (elem && (drawer.scrollTop < (elem.offsetTop - 30 - elem.offsetHeight) || drawer.scrollTop > elem.offsetTop))
			drawer.scrollTop = elem.offsetTop - (drawer.offsetHeight / 2 - elem.offsetHeight/2);

		return (
			text ||
			t("Forms.REQUIERED_ERR", {title: quest.title})
		);
	}

	for (let quest of section.questions)
	{
		if (quest.answerRequired)
		{
			if (!quest.answers?.length)
				return (error(quest));
			else {
				let resp = quest.answers.map(a => { const v = answerValue(a); return (v || v === 0 ? a : false); }).filter(a => (a === false));
				if (resp.length)
					return (error(quest));
			}
		} else if (quest.answers?.length) {
			let check = checkQuestion(quest);
			if (check !== true)
				return (error(quest, check));
		}
	}
	return (true);
}
